import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import styles from 'components/Dot/Dot.module.scss'

const Dot = ({ touched, error, size = 'm' }) => {
  return touched || error ? (
    <div className={styles['wrapper']}>
      <div
        className={clsx(styles['dot'], styles[`dot_size-${size}`], {
          [styles[`dot_touched`]]: touched,
          [styles[`dot_error`]]: error,
        })}
      />
    </div>
  ) : null
}

export default Dot

Dot.propTypes = {
  touched: PropTypes.oneOfType([PropTypes.oneOf([undefined]), PropTypes.bool]),
  error: PropTypes.oneOfType([PropTypes.oneOf([undefined]), PropTypes.bool]),
  size: PropTypes.oneOf(['s', 'm']),
}
